export const countryCodes = [
  { name: "United Kingdom", code: "GB", phoneCode: "+44" },
  { name: "United States", code: "US", phoneCode: "+1" },
  { name: "France", code: "FR", phoneCode: "+33" },
  { name: "Germany", code: "DE", phoneCode: "+49" },
  { name: "Poland", code: "PL", phoneCode: "+48" },
  { name: "Netherlands", code: "NL", phoneCode: "+31" },
];
